module.exports = __webpack_public_path__ + "static/media/P13.4398ae49.png";